import { createFeatureSelector, createSelector, select } from "@ngrx/store";
import { pipe } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";
import * as fromAuth from "./auth.reducer";
import { AuthState } from "./auth.state";

export const selectAuthState = createFeatureSelector<AuthState>(
    fromAuth.authFeatureKey
);

/**
 * Whether an authenticated session currently exists.
 * Same predicate as the `isAuthenticated` pipe below, exposed as a selector so
 * it can be read synchronously (`store.selectSignal`) inside effects.
 */
export const selectIsAuthenticated = createSelector(
    selectAuthState,
    auth => auth?.isLoggingIn !== true
        && auth?.isAuthenticated === true
        // && auth?.tokenIsValid === true
        && auth?.token !== undefined
        && auth?.refreshToken !== undefined
        && auth?.loginFailedReason === undefined
);

export const isAuthenticated = pipe(
    select(selectIsAuthenticated),
    distinctUntilChanged(),
);

// Claims
const selectTokenClaims = createSelector(
    selectAuthState,
    state => state?.claims
);

export const selectSas = createSelector(
    selectTokenClaims,
    claims => claims?.sas
);

export const selectHasDriverscam = createSelector(
    selectTokenClaims,
    claims => claims?.hasDriverscam === true
);
export const selectEnetToken = createSelector(
    selectTokenClaims,
    claims => claims?.enetToken
);

/**
 * Select the ID of the current lesson or liveLesson.
 * ATTENTION: this claim is _not_ available for TEACHER clients!
 */
export const selectLessonId = createSelector(
    selectTokenClaims,
    claims => {
        const clientType = claims?.clientType;
        if (clientType === 'Teacher') {
            console.error('Selecting lessonId from Teacher auth will always return undefined.');
            return undefined;
        }

        return claims?.lessonId;
    }
);
